import React from "react";
import { Typography, Paper, Alert } from "@mui/material";
import { styled } from "@mui/material/styles";
import Card from "../../Reuse/UI/Card";
import StyledButton from "../../Reuse/UI/StyledButton";
import FormBox from "../../Reuse/UI/FormBox";
import { StyledTextInput } from "../../Reuse/FormInput";
import { InfoFillIcon } from "../../Reuse/Icon";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(0),
  textAlign: "center",
  color: theme.palette.text.secondary,
  ...theme.applyStyles("dark", {
    backgroundColor: "#1A2027",
  }),
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

const LoginForm = ({
  control,
  handleSubmit,
  onSubmit,
  errors,
  isValid,
  isSubmitting,
}) => {
  return (
    <Card variant="outlined" sx={{ overflow: "auto" }}>
      <Item elevation={0}>
        <Typography
          variant="h2"
          gutterBottom
          sx={{ textAlign: "left", width: "100%" }}
        >
          Sign in to your account
        </Typography>
      </Item>

      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        <FormBox elevation={0}>
          <Item elevation={0}>
            <StyledTextInput
              name="email"
              control={control}
              type="email"
              placeholder="Enter Email"
              label="Email"
              rules={{ required: "Email is required" }}
            />
          </Item>

          <Item elevation={0}>
            <StyledTextInput
              name="password"
              control={control}
              type="password"
              placeholder="Enter Password"
              label="Password"
              rules={{ required: "Password is required" }}
            />
          </Item>

          {errors.root?.message && (
            <Item elevation={0} sx={{ justifyContent: "flex-start" }}>
              <Alert
                severity="error"
                color="#E62E05"
                variant="outlined"
                iconMapping={{
                  error: <InfoFillIcon sx={{ color: "#E62E05" }} />,
                }}
                sx={(theme) => ({
                  border: 0,
                  background: "transparent",
                  color: theme.palette.text.warning,
                  "& .MuiAlert-message": {
                    color: theme.palette.text.warning,
                    fontWeight: 400,
                    fontSize: "14px",
                    lineHeight: "20px",
                  },
                })}
              >
                {errors.root.message}
              </Alert>
            </Item>
          )}

          <Item elevation={0}>
            <StyledButton
              type="submit"
              variant="contained"
              size="large"
              fullWidth
              disabled={!isValid || isSubmitting}
            >
              Continue
            </StyledButton>
          </Item>
        </FormBox>
      </form>
    </Card>
  );
};

export default LoginForm;
